module.exports = __webpack_public_path__ + "img/cloud_right.edde4ece.png";